var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"Biểu Đồ Chốt Đơn Nhân Viên"}},[_c('line-chart',{attrs:{"data":_vm.data,"height":100}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }